import { render, staticRenderFns } from "./AddRiskPointControl.vue?vue&type=template&id=0d06c53a&scoped=true"
import script from "./AddRiskPointControl.vue?vue&type=script&lang=js"
export * from "./AddRiskPointControl.vue?vue&type=script&lang=js"
import style0 from "./AddRiskPointControl.vue?vue&type=style&index=0&id=0d06c53a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d06c53a",
  null
  
)

export default component.exports